import React, { Component, Fragment } from 'react';
import Refresh from '../components/refresh';
import AddNew from '../components/addnew';
import moment from 'moment';
import 'moment-timezone';

import './feed.css';

export default class Feed extends Component {
	constructor(props) {
    super(props);
		this.refresh = this.refresh.bind(this);
		this.state = {};
		console.log('Feed init', this.state);
  }
	componentWillMount() {
		const timezone = moment.tz.guess();
		this.setState({ timezone: timezone })
	}
	refresh(data) {
		this.props.onRefresh(data);
	}
	render() {
		console.log('Feed renders', this.props, this.state);
		if(!this.props.posts) {
			return (
				<div id="feed">
					<p>No posts around you at the moment. Check back later or change your location.</p>
					<Refresh onRefresh={ this.refresh }/>
					<AddNew/>
				</div>
			)
		}

		return (
      <main id="feed">
				<div id="posts">
					{this.props.posts.map((post, i) =>
						<section className="post" key={ post.id }>
							<div className="content" key={ post.id }>
								{ post.post }
							</div>
							<div className="footer">
								<dl className="location">
									<dt>{ Math.round(post.distance * 1000) / 1 } m away</dt>
									<dd>{ post.latitude }, { post.longitude }</dd>
								</dl>
								<dl className="expiricy">
									<dt>Expires { moment.utc(post.upt).local().endOf(moment()).fromNow() }</dt>
									<dd>{ moment.utc(post.posted).local().format("YYYY-MM-DD HH:mm") } - { moment.utc(post.upt).local().format("YYYY-MM-DD HH:mm") }</dd>
								</dl>
								<dl className="profile">
								{ post.name ? <Fragment><dt className="name">Name</dt><dd className="name">{ post.name }</dd></Fragment> : false }
								{ post.description ? <Fragment><dt className="description">Description</dt><dd className="description">{ post.description }</dd></Fragment> : false }
								{ post.phone? <Fragment><dt className="phone">Phone</dt><dd className="phone">{ post.phone }</dd></Fragment> : false }
								{ post.url ? <Fragment><dt className="url">URL</dt><dd className="url">{ post.url }</dd></Fragment> : false }
								{ post.email ? <Fragment><dt className="email">E-mail</dt><dd className="email">{ post.email }</dd></Fragment> : false }
								</dl>
							</div>
						</section>
					)}
				</div>
				<Refresh onRefresh={ this.refresh }/>
        <AddNew/>
      </main>
		);
	}
}



// WEBPACK FOOTER //
// ./src/view/feed.jsx